import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SrPartnerSection from 'client/components/SrPartnerSection';
import SrBillingRenewalModal from 'client/components/SrBillingRenewalModal/SrBillingRenewalModal';
import SrPartnerBillingSectionHeader, {
  SR_PARTNER_BILLING_MODAL_DISCOUNT,
  SR_PARTNER_BILLING_MODAL_RENEWAL,
} from 'client/components/SrPartnerBillingSection/SrPartnerBillingSectionHeader';
import SrBillingDiscountModal from 'client/components/SrBillingDiscountModal/SrBillingDiscountModal';

const SrPartnerBillingSection = ({
  currentUser,
  markets,
  partner,
  listingsEligibleForDiscounts,
  handleRenewalSubmit,
  handleDiscountSubmit,
}) => {
  const [activeModal, setActiveModal] = useState(null);
  return (
    <>
      <SrPartnerSection
        title="Billing"
        headerRow={
          <SrPartnerBillingSectionHeader currentUser={currentUser} openModal={setActiveModal} />
        }
      />
      {activeModal === SR_PARTNER_BILLING_MODAL_RENEWAL && (
        <SrBillingRenewalModal
          markets={markets}
          billingFees={partner.billingFees}
          invoiceSchedule={partner.invoiceSchedule}
          onSubmit={(payload) => {
            setActiveModal(null);
            return handleRenewalSubmit(payload);
          }}
          onClose={() => setActiveModal(null)}
        />
      )}
      {activeModal === SR_PARTNER_BILLING_MODAL_DISCOUNT && (
        <SrBillingDiscountModal
          listings={listingsEligibleForDiscounts}
          onSubmit={(payload) => {
            setActiveModal(null);
            const _payload = { ...payload };

            _payload.listingId = !isNaN(payload.applyTo) ? parseInt(payload.applyTo, 10) : null;

            delete _payload.applyTo;

            return handleDiscountSubmit(_payload);
          }}
          onClose={() => setActiveModal(null)}
        />
      )}
    </>
  );
};

SrPartnerBillingSection.displayName = 'SrPartnerBillingSection';
SrPartnerBillingSection.propTypes = {
  currentUser: PropTypes.object.isRequired,
  handleRenewalSubmit: PropTypes.func.isRequired,
  handleDiscountSubmit: PropTypes.func.isRequired,
  markets: PropTypes.array.isRequired,
  listingsEligibleForDiscounts: PropTypes.array.isRequired,
  partner: PropTypes.object.isRequired,
};

export default SrPartnerBillingSection;
